import React from 'react'
import { Skeleton } from '@fs/zion-ui'

export default function MergeHeaderHeadingSkeleton(): JSX.Element {
  return <Skeleton.H4 subheadingLineCount={1} width={98} />
}
